import React, { useState, useMemo } from "react";
import "./Newuserlogin.css";
import axios from "axios";
import Popup from "../component/PopUp/Popup";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../config";

const Newuserlogin = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [finalJson, setFinalJson] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  try {
    const rawUserData = sessionStorage.getItem("userData");
    if (rawUserData) {
      // console.log("🔎 Newuserlogin → sessionStorage.userData (raw):", rawUserData);
      // console.log("🔎 Newuserlogin → sessionStorage.userData (parsed):", JSON.parse(rawUserData));
    } else {
      // console.log("ℹ️ Newuserlogin → no sessionStorage.userData found");
    }
  } catch (e) {
    // console.log("⚠️ Newuserlogin → failed to parse userData");
  }

  // Decide where to go after this page finishes
  const nextAfterNewUser = useMemo(() => {
    return (
      location.state?.next ||
      sessionStorage.getItem("postNewUserNext") ||
      "/whatsappregister"
    );
  }, [location.state]);

  const handleCreate = async () => {
    setError("");
    setSuccess("");

    if (!userId || !password || !confirmPassword) {
      setError("All fields are required.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    const oldUserId = sessionStorage.getItem("oldUserId") || "";
    const oldPassword = sessionStorage.getItem("oldUserPassword") || "";

    const result = {
      oldUserId,
      oldPassword,
      newUserId: userId,
      newPassword: password,
    };

    // (Added) Debug: show what we'll send
    // console.log("📤 update-credentials payload:", result);

    try {
      setLoading(true);
      const response = await axios.post(
        `${config.BASE_URL}/api/auth/update-credentials`,
        result
      );

      // (Added) Debug response
      // console.log("📨 update-credentials response:", response);

      setMessage(response?.data?.message || "Credentials updated successfully.");
      setShowPopup(true);
      setSuccess("Stored successfully!");
      setFinalJson(result);

      // Clean up only what we don't need; keep userData & next route intact
      sessionStorage.removeItem("oldUserId");
      sessionStorage.removeItem("oldUserPassword");

      // Optional: remove the helper now that we're about to navigate
      const next = nextAfterNewUser || "/whatsappregister";
      sessionStorage.removeItem("postNewUserNext");

      // Briefly show popup, then go to WhatsApp register
      setTimeout(() => {
        setShowPopup(false);
        // (Added) Debug: where we navigate
        // console.log("➡️ Navigating to:", next);
        navigate(next, { replace: true });
      }, 1200);
    } catch (err) {
      console.error("Error updating credentials:", err);
      setError(
        err?.response?.data?.message ||
          err?.response?.data ||
          "Failed to update credentials. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newuser-body">
      <div className="newuser-container">
        {showPopup && (
          <Popup
            title="Credentials Updated Successfully"
            message={message}
            type="Success"
            onClose={() => setShowPopup(false)}
          />
        )}

        <h2>Change ID & Password</h2>

        <input
          className="newuser-input"
          type="text"
          placeholder="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <input
          className="newuser-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          className="newuser-input"
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        {error && <p className="error-message">{error}</p>}

        {success && (
          <div className="success-message">
            <strong>✅ Stored Successfully!</strong>
            <p>{success}</p>
            {finalJson && <pre>{JSON.stringify(finalJson, null, 2)}</pre>}
          </div>
        )}

        <button
          onClick={handleCreate}
          className="newuser-button"
          disabled={loading}
        >
          {loading ? "Saving..." : "Create"}
        </button>

        {/* (Optional) Show where we'll go next */}
        {/* <div style={{ marginTop: 10, fontSize: 12, color: "#666" }}>
          Next step after success: <code>{nextAfterNewUser}</code>
        </div> */}
      </div>
    </div>
  );
};

export default Newuserlogin;